export default object => ({
  id: object.id,
  reference: object.reference,
  categoryName: object.categoryName,
  value: object.value,
});
